import React, { useCallback, useEffect, useState } from "react";
import toast from "react-hot-toast";
import { API_URL } from "../../../_services/apiUrl";
import { get, imageurl } from "../../../_services/apiService";
import Layout from "../../Shared/Layout";
import { useNavigate } from "react-router-dom";
import FilterByPrice from "../../Shared/FilterByPrice";
import RatingAndWishlist from "../Products/RatingAndWishlist";
import { useWishlist } from "../../../context/wishlistContext";
import { Toaster } from "react-hot-toast";

const ProductBySubCategoryId = () => {
    const productSubCategoryId = localStorage.getItem('productSubCategoryId');
    const isLoggedIn = localStorage.getItem('isLoggedIn');
    const [productBySubCategoryId, setProductBySubCategoryId] = useState([]);
    const [selectedCategories, setSelectedCategories] = useState([]);
    const [filteredProducts, setFilteredProducts] = useState([]);
    const [selectedPriceRanges, setSelectedPriceRanges] = useState([]);
    const [isSidebarVisible, setIsSidebarVisible] = useState(false);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const { addToWishlist, removeFromWishlist } = useWishlist();
    const [wishListForm, setWishListForm] = useState({
        wishProductId: 0,
        isLoggedIn: isLoggedIn ? Number(isLoggedIn) : 0,
        productId: 0,
        isActive: true,
        createdBy: 0
    });

    const GetProductDetailBySubCategoryId = useCallback(async () => {
        try {
            setLoading(true);
            const response = await get(API_URL.GetProductDetailBySubCategoryIdWithisLoggedIn + `?pSubCategoryId=${productSubCategoryId}&pisLoggedIn=${isLoggedIn || 0}`);
            if (response.isSuccess === 200) {
                setProductBySubCategoryId(response?.data)
            }
        } catch (error) {
            toast.error('An error occurred. Please try again later.');
        } finally {
            setLoading(false);
        }
    }, [productSubCategoryId, isLoggedIn]);

    useEffect(() => {
        GetProductDetailBySubCategoryId();
    }, [GetProductDetailBySubCategoryId]);

    const truncateProductName = (productBySubCategoryId, maxWords = 3) => {
        if (!productBySubCategoryId) return '';
        const words = productBySubCategoryId.split(' ');
        if (words.length <= maxWords) {
            return productBySubCategoryId;
        }
        return `${words.slice(0, maxWords).join(' ')}...`;
    };

    const onProductDetail = (item) => {
        const existingItemDetails = JSON.parse(localStorage.getItem('itemDetail')) || [];
        const existingCartItemDetails = JSON.parse(localStorage.getItem('cartItemDetail')) || [];

        if (existingItemDetails.length > 0 || existingCartItemDetails.length > 0) {
            localStorage.removeItem('cartItemDetail');
            localStorage.removeItem('itemDetail');
        }
        localStorage.setItem('productId', item?.productId);
        localStorage.setItem('priviousUrl', `/${item?.categoryName.replace(/\s+/g, '_')}/${item?.productSubCategoryName.replace(/\s+/g, '_')}/${item?.productName.replace(/\s+/g, '_')}`);

        navigate(`/${item?.categoryName.replace(/\s+/g, '_')}/${item?.productSubCategoryName.replace(/\s+/g, '_')}/${item?.productName.replace(/\s+/g, '_')}`);
    }

    // filter and short data function all

    const [selectedSort, setSelectedSort] = useState('default');

    const handleSortChange = (e) => {
        setSelectedSort(e.target.value);
    };

    const handlePriceCheckboxChange = (priceRange) => {
        const updatedSelectedPriceRanges = selectedPriceRanges.includes(priceRange)
            ? selectedPriceRanges.filter(range => range !== priceRange)
            : [...selectedPriceRanges, priceRange];

        setSelectedPriceRanges(updatedSelectedPriceRanges);
    };

    useEffect(() => {
        if (productBySubCategoryId && productBySubCategoryId.length > 0) {
            let filtered = productBySubCategoryId.filter(product => {
                // Filter by selected categories
                const isInCategory = selectedCategories.length === 0 || selectedCategories.includes(product.productCategoryId);

                // Filter by selected price range
                const isInPriceRange = selectedPriceRanges.length === 0 || selectedPriceRanges.some(range => {
                    switch (range) {
                        case '0-399':
                            return product.unitPrice >= 0 && product.unitPrice <= 399;
                        case '400-799':
                            return product.unitPrice >= 400 && product.unitPrice <= 799;
                        case '800-1099':
                            return product.unitPrice >= 800 && product.unitPrice <= 1099;
                        case '1100-1999':
                            return product.unitPrice >= 1100 && product.unitPrice <= 1999;
                        case '2000+':
                            return product.unitPrice >= 2000;
                        default:
                            return true;
                    }
                });

                return isInCategory && isInPriceRange;
            });

            // Apply sorting based on selected sort option
            if (selectedSort === "priceLowToHigh") {
                filtered.sort((a, b) => a.unitPrice - b.unitPrice);
            } else if (selectedSort === "priceHighToLow") {
                filtered.sort((a, b) => b.unitPrice - a.unitPrice);
            } else if (selectedSort === "rating") {
                filtered.sort((a, b) => b.rating - a.rating);
            }

            setFilteredProducts(filtered);
        }
    }, [selectedCategories, selectedPriceRanges, productBySubCategoryId, selectedSort]);

    const handleClearFilters = () => {
        setSelectedCategories([]);
        setSelectedPriceRanges([]);
        setSelectedSort("default");
    };

    const toggleSidebar = () => {
        setIsSidebarVisible(prevState => !prevState);
    };

    const onWishlistToggle = async (item) => {
        if (isLoggedIn) {
            const updatedWishListForm = {
                ...wishListForm,
                productId: item?.productId || 0
            };

            setWishListForm(updatedWishListForm);

            if (item.wishStatus) {
                await removeFromWishlist(item);
                GetProductDetailBySubCategoryId();
                toast.success('Remove to wishlist!');
            } else {
                await addToWishlist(updatedWishListForm);
                GetProductDetailBySubCategoryId();
                toast.success('Add to wishlist!');
            }
        } else {
            navigate('/login');
        }
    };

    return (
        <Layout>
            <Toaster position="top-right" />
            <section className="same_space">
                <div className="container">
                    <div className="hedding_product row justify-content-end align-items-end py-3">
                        <div className="icon_wepper_filter col-md-12 col-7 d-sm-flex align-items-center justify-content-sm-end">
                            <h6 className="mb-1" style={{ paddingRight: '10px' }}>Sort by : </h6>
                            <div>
                                <select
                                    defaultValue="default"
                                    value={selectedSort}
                                    onChange={handleSortChange}
                                    className="sort_by_select"
                                >
                                    <option value="default">All</option>
                                    <option value="priceLowToHigh">Low to High</option>
                                    <option value="priceHighToLow">High to Low</option>
                                </select>
                            </div>
                        </div>
                        <div className="filter_toggle_mobile col-5">
                            <button onClick={toggleSidebar}>Filter
                                <span><svg
                                    id="Layer_1"
                                    height="22"
                                    width="22"
                                    viewBox="0 0 24 24"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <g width="100%" height="100%" transform="matrix(1,0,0,1,0,0)">
                                        <switch>
                                            <g>
                                                <path
                                                    d="m18 24h-12c-3.3 0-6-2.7-6-6v-12c0-3.3 2.7-6 6-6h12c3.3 0 6 2.7 6 6v12c0 3.3-2.7 6-6 6z"
                                                    fill="#ffffff" // Green fill
                                                />
                                                <path
                                                    d="m12 15.5c-.2 0-.5-.1-.6-.2l-6-5c-.4-.4-.5-1-.1-1.4s1-.5 1.4-.1l5.4 4.5 5.4-4.3c.4-.3 1.1-.3 1.4.1.4.4.3 1-.1 1.4 0 0 0 0-.1 0l-6 4.8c-.3.2-.5.2-.7.2z"
                                                    fill="#000000" // White fill
                                                />
                                            </g>
                                        </switch>
                                    </g>
                                </svg>
                                </span>
                            </button>
                        </div>
                    </div>
                    <div className="row mt-sm-4 mt-2">
                        <div className={`col-md-3 col-12 filter_sidebar ${isSidebarVisible ? 'show' : 'hide'}`}>
                            <FilterByPrice
                                selectedPriceRanges={selectedPriceRanges}
                                handlePriceCheckboxChange={handlePriceCheckboxChange}
                                handleClearFilters={handleClearFilters}
                                setIsSidebarVisible={setIsSidebarVisible}
                            />
                        </div>
                        <div className="col-md-9 col-12">
                            {filteredProducts !== null ? (
                                filteredProducts.length > 0 ? (
                                    <div className="shop_flex_weppr row">
                                        {filteredProducts?.map((item, index) => {
                                            const rating = item.avgRatting;

                                            const headerImage = item.productImageDtos?.find(image => image.isHeader === true);
                                            const imagePath = headerImage
                                                ? `${imageurl}${headerImage.imgPath}`
                                                : item?.productSkuDtos?.[0]?.productImageDtos?.length > 0
                                                    ? `${imageurl}${item.productSkuDtos[0].productImageDtos[0].imgPath}`
                                                    : item?.productImageDtos?.length > 0
                                                        ? `${imageurl}${item.productImageDtos[0].imgPath}`
                                                        : '../images/defaultImage.png';

                                            return (
                                                <div key={index} className="shop_inner col-lg-3 col-sm-4 col-6 mb-sm-4 mb-0 pb-sm-4 pb-3">
                                                    <div key={`${index}`} onClick={() => onProductDetail(item)}>
                                                        <img className="curser-pointer" src={imagePath}  width="50" />
                                                        <h2 className="curser-pointer" title={item?.productName}>{truncateProductName(item?.displayName)}</h2>
                                                    </div>
                                                    <RatingAndWishlist
                                                        item={item}
                                                        rating={rating}
                                                        onWishlistToggle={onWishlistToggle}
                                                    />
                                                </div>
                                            );
                                        })}
                                    </div>
                                ) : (
                                    <p className="text-white">No data available</p>
                                )
                            ) : (
                                loading ?
                                    <p>Loading...</p> : null
                            )}
                        </div>
                    </div>
                </div>
            </section>
        </Layout>
    )
}

export default ProductBySubCategoryId;